/* tslint:disable */
/* eslint-disable */
/**
 * acomo API docs
 * acomoのAPI仕様書です。
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ExecutionSystemActionSubject = {
    Engine: 'Engine',
    Ai: 'Ai'
} as const;
export type ExecutionSystemActionSubject = typeof ExecutionSystemActionSubject[keyof typeof ExecutionSystemActionSubject];


export function instanceOfExecutionSystemActionSubject(value: any): boolean {
    for (const key in ExecutionSystemActionSubject) {
        if (Object.prototype.hasOwnProperty.call(ExecutionSystemActionSubject, key)) {
            if (ExecutionSystemActionSubject[key as keyof typeof ExecutionSystemActionSubject] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ExecutionSystemActionSubjectFromJSON(json: any): ExecutionSystemActionSubject {
    return ExecutionSystemActionSubjectFromJSONTyped(json, false);
}

export function ExecutionSystemActionSubjectFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecutionSystemActionSubject {
    return json as ExecutionSystemActionSubject;
}

export function ExecutionSystemActionSubjectToJSON(value?: ExecutionSystemActionSubject | null): any {
    return value as any;
}

export function ExecutionSystemActionSubjectToJSONTyped(value: any, ignoreDiscriminator: boolean): ExecutionSystemActionSubject {
    return value as ExecutionSystemActionSubject;
}

